import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CredentialsService } from '@core/services/credentials.service';
import { Logger } from '@core/services/logger.service';
import { AuthService } from '../services/auth.service';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private credentialsService: CredentialsService,private authService:AuthService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.credentialsService.isAuthenticated()) {
      const isAcknowledged = sessionStorage.getItem('acknowledgment');
      if (!JSON.parse(isAcknowledged)) {
        this.authService.logout();
        return false; 
      }
      return true;
    }
    log.debug('Not authenticated, redirecting and adding redirect url...');
    this.router.navigate(['/auth/login']);
    return false;
  }
}
